import React from 'react';
import {Col, Container, Row, Nav, Tab, Accordion} from "react-bootstrap";

function Amazonservices(props) {
    return (
        <section className="tekgrip_section tekrevol_dark_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="my-auto">
                        <div className="example" data-text="GCP Businesses">
                            <h2>Build High-Performance Infrastructure Through GCP Cloud Services</h2>
                        </div>
                        {/*<div*/}
                        {/*    className="main_para"><p>SAP is a one-of-its-kind, turnkey ERP system that synchronizes*/}
                        {/*    different business departments and brings them on one page to achieve organizational goals.*/}
                        {/*    It significantly improves internal communications, opens avenues for enhanced, recorded*/}
                        {/*    collaborations, and allows better internal reporting.</p>*/}
                        {/*</div>*/}
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tekgrip_tabs deskstop_version">
                        <Tab.Container id="" defaultActiveKey="0">
                            <Row>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="0">Assess Business Requirements</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="1">Unlock Advanced IT Operations</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="2">Evaluate Business Results and Improve</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Tab.Content>

                                        <Tab.Pane eventKey="0">
                                            <p>Our GCP cloud services start with a comprehensive needs assessment. We assign a dedicated Google Cloud service provider to each client, who then audits the current state of data collection, storage, and utilization and creates a strategy for scaling with Google Cloud.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="1">
                                            <p>The next step is translating the strategy into design, development, and deployment. These processes include migration, delivery of digital products and SaaS, and optimization of business processes.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="2">
                                            <p>Google Cloud makes it easier to report business performance. With better data representations and opportunities for utilization, TekRevol helps businesses innovate their existing processes and achieve their operational and financial goals faster.</p>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Col>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="mobile_version">
                        <div className="tekrevol_mobile_accordion">
                            <Accordion
                                defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Assess Business Requirements</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Our GCP cloud services start with a comprehensive needs assessment. We assign a dedicated Google Cloud service provider to each client, who then audits the current state of data collection, storage, and utilization and creates a strategy for scaling with Google Cloud.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Unlock Advanced IT Operations</Accordion.Header>
                                    <Accordion.Body>
                                        <p>The next step is translating the strategy into design, development, and deployment. These processes include migration, delivery of digital products and SaaS, and optimization of business processes.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Evaluate Business Results and Improve</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Google Cloud makes it easier to report business performance. With better data representations and opportunities for utilization, TekRevol helps businesses innovate their existing processes and achieve their operational and financial goals faster.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Amazonservices;